import { ColDef } from 'ag-grid-community';
import type { TabsProps } from 'antd';
import { Tabs } from 'antd';
import dayjs from 'dayjs';
import React from 'react';
import '../../../style.scss';

import { IConditionSV2, IDetailGroup, IVConditionFilterV2 } from '../../../../../../api/groupCustomerV2/groupCustomerV2Api';
import { GROUPTYPE, IDataFilterGroupList, IInforAddGroup, IPagination, ISelectedCustomer } from '../AddNewGroup';
import AG_CustomerList from './AG_CustomerList';
import AG_Decentralization, { ISelectedUserAccount } from './AG_Decentralization';
dayjs.locale('vi');

interface props {
    loadingTableModal: boolean
    memoizedColumnDefs: ColDef<any, any>[];
    paginationCustomers: IPagination

    inforAddGroup?: IInforAddGroup | IDetailGroup
    selectedIdCustomerV9: ISelectedCustomer[]
    selectedIdAccount: ISelectedUserAccount[]

    setSelectedIdCustomerV9: React.Dispatch<React.SetStateAction<ISelectedCustomer[]>>
    setSelectedIdAccount: React.Dispatch<React.SetStateAction<ISelectedUserAccount[]>>

    onPaginationChange: (page: number, pageSize: number) => void;

    //Kh có dk 
    tableDataCondAll: any[]

    dataFilterListCondUnmatchedCustomers: IDataFilterGroupList

    tableDataCondMatchedCustomers: any[];
    tableDataCondUnmatchedCustomers: any[];

    infoOperator: IVConditionFilterV2
    selectedIdCondUnmatchedCustomers: Set<number>

    paginationMatchedCustomers: IPagination;
    paginationCondUnmatchedCustomers: IPagination;

    setSelectedCondIdUnmatchedCustomers: (data: Set<number>) => void;
    setDataFilterListCondUnmatchedCustomers: (dataFilterList: IDataFilterGroupList) => void;
    onPaginationCondMatchedCustomers: (page: number, pageSize: number) => void;
    onPaginationCondUnmatchedCustomers: (page: number, pageSize: number) => void;

    setModalCondition: (visible: boolean) => void;
    //Kh có dk
}

const AG_ConditionComponent: React.FC<props> = ({
    loadingTableModal,
    memoizedColumnDefs,
    paginationCustomers,

    inforAddGroup,
    selectedIdCustomerV9,
    selectedIdAccount,

    setSelectedIdCustomerV9,
    setSelectedIdAccount,

    onPaginationChange,

    //Kh có dk 
    tableDataCondAll,

    dataFilterListCondUnmatchedCustomers,

    tableDataCondMatchedCustomers,
    tableDataCondUnmatchedCustomers,

    infoOperator,
    selectedIdCondUnmatchedCustomers,

    paginationMatchedCustomers,
    paginationCondUnmatchedCustomers,

    setSelectedCondIdUnmatchedCustomers,
    setDataFilterListCondUnmatchedCustomers,
    onPaginationCondMatchedCustomers,
    onPaginationCondUnmatchedCustomers,

    setModalCondition
    //Kh có dk
}) => {

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: <span className='custom-page-css text-base font-regular'>Danh sách khách hàng</span>,
            children:
                <AG_CustomerList
                    loadingTableModal={loadingTableModal}
                    memoizedColumnDefs={memoizedColumnDefs}
                    paginationCustomers={paginationCustomers}

                    selectedIdCustomerV9={selectedIdCustomerV9}

                    setSelectedIdCustomerV9={setSelectedIdCustomerV9}

                    onPaginationChange={onPaginationChange}

                    //Kh có dk 

                    dataFilterListCondUnmatchedCustomers={dataFilterListCondUnmatchedCustomers}
                    paginationCondMatchedCustomers={paginationMatchedCustomers}
                    paginationCondUnmatchedCustomers={paginationCondUnmatchedCustomers}

                    infoOperator={infoOperator}
                    selectedIdCondUnmatchedCustomers={selectedIdCondUnmatchedCustomers}

                    tableDataCondMatchedCustomers={tableDataCondMatchedCustomers}
                    tableDataCondUnmatchedCustomers={tableDataCondUnmatchedCustomers}

                    setSelectedIdUnmatchedCustomers={setSelectedCondIdUnmatchedCustomers}
                    setDataFilterListCondUnmatchedCustomers={setDataFilterListCondUnmatchedCustomers}
                    onPaginationCondMatchedCustomers={onPaginationCondMatchedCustomers}
                    onPaginationCondUnmatchedCustomers={onPaginationCondUnmatchedCustomers}

                    setModalCondition={setModalCondition}
                    //Kh có dk

                    tableDataCondAll={tableDataCondAll}



                />,
        },
        ...(inforAddGroup?.status === GROUPTYPE.SHARED
            ? [
                {
                    key: '2',
                    label: (
                        <span className="custom-page-css text-base font-regular">
                            Phân quyền
                        </span>
                    ),
                    children: (
                        <AG_Decentralization
                            inforAddGroup={inforAddGroup ?? undefined}
                            selectedIdAccount={selectedIdAccount}
                            setSelectedIdAccount={setSelectedIdAccount}
                        />
                    ),
                },
            ]
            : []),
    ];

    const onChange = (key: string) => {
        // console.log(key);
    };

    return (
        <div className="custom-page-css w-full flex flex-col gap-2 bg-white p-4 rounded">
            <div className="custom-page-css w-full flex gap-2 items-center">
                <Tabs defaultActiveKey="1" items={items} onChange={onChange} className='w-full' />

            </div>

        </div>
    )
}

export default React.memo(AG_ConditionComponent)
